module.exports = __webpack_public_path__ + "static/staff-9-58113c29dc5dd676bbac86cd43dcfddb.png";